interface IErrorLabel {
  children: string;
}

export const ErrorLabel = ({ children }: IErrorLabel) => (
  <label className="text-xs font-medium text-error-700 pl-4">{children}</label>
);